module.exports = __webpack_public_path__ + "img/desktop_cover_sol.4d0e6c95.png";